import React from 'react';

import {
  VirtualTableColumnCellsEnum,
  VirtualTableSortableColumnDirectionsEnum,
} from '../../../../../../../../../src/components/common/table/helpers/tableHelpers';
import {
  SortableTableColumn,
  TableColumn,
} from '../../../../../../../../../src/components/common/table/tableColumn';
import {Trans} from '../../../../../../../../shared/helpers/src/internationalization/react';
import {VisualSizesEnum} from '../../../../../../../../shared/ui/src/styles/commonStyles';

/*
 * Constants.
 */

const cardGroupsTableNameColumnId = 'card-groups-name';

enum ColumnWidthsEnum {
  EXTRA_LARGE = 250,
  LARGE = 200,
  MEDIUM = 132,
  SMALL = 83,
}

export enum CardGroupsTableColumnsEnum {
  NAME = 'name',
  ACCESS = 'access',
  CONTACTS = 'contacts',
  LAST_USED = 'last_used',
  DATE_CREATED = 'date_created',
}

export const cardGroupsTableColumns: ReadonlyArray<TableColumn<CardGroupsTableColumnsEnum>> = [
  {
    id: cardGroupsTableNameColumnId,
    title: <Trans id="card-groups-table-col-name">Name</Trans>,
    type: CardGroupsTableColumnsEnum.NAME,
    cellType: VirtualTableColumnCellsEnum.ICON,
    settings: {
      sticky: {
        isSticky: true,
      },
      cellWidth: {
        shouldFillRemainingWidth: true,
        minWidth: ColumnWidthsEnum.EXTRA_LARGE,
        maxWidth: ColumnWidthsEnum.EXTRA_LARGE,
      },
      loading: {
        iconSize: VisualSizesEnum.MEDIUM,
      },
    },
  },
  {
    id: 'card-groups-access',
    title: <Trans id="card-groups-table-col-access">Access</Trans>,
    type: CardGroupsTableColumnsEnum.ACCESS,
    cellType: VirtualTableColumnCellsEnum.NAMESPACE,
    settings: {
      cellWidth: {
        width: ColumnWidthsEnum.LARGE,
      },
    },
  },
  {
    id: 'card-groups-total-contacts',
    title: <Trans id="card-groups-table-col-total-contacts">Contacts</Trans>,
    type: CardGroupsTableColumnsEnum.CONTACTS,
    cellType: VirtualTableColumnCellsEnum.NUMBER,
    settings: {
      cellWidth: {
        width: ColumnWidthsEnum.MEDIUM,
      },
    },
  },
  {
    id: 'card-groups-last-used',
    title: <Trans id="card-groups-table-col-last-used">Last used</Trans>,
    type: CardGroupsTableColumnsEnum.LAST_USED,
    cellType: VirtualTableColumnCellsEnum.DATE,
    settings: {
      cellWidth: {
        width: ColumnWidthsEnum.MEDIUM,
      },
    },
  },
  {
    id: 'card-groups-date-created',
    title: <Trans id="card-groups-table-col-date-created">Date created</Trans>,
    type: CardGroupsTableColumnsEnum.DATE_CREATED,
    cellType: VirtualTableColumnCellsEnum.DATE,
    settings: {
      cellWidth: {
        width: ColumnWidthsEnum.MEDIUM,
      },
    },
  },
];

export const cardGroupsTableSortableColumns: ReadonlyArray<SortableTableColumn> = [
  {
    id: cardGroupsTableNameColumnId,
    directions: [
      VirtualTableSortableColumnDirectionsEnum.ASCENDING,
      VirtualTableSortableColumnDirectionsEnum.DESCENDING,
    ],
  },
];
